import EmptyState from '../components/EmptyState';

export default function Phrases() {
  return (
    <EmptyState
      title="Phrases"
      description="Common phrase inventories and translation coverage"
    />
  );
}
